import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-796f034a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-your-event--section ticket-your-event--section--testimonials" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Don't just take our word for it", -1))
const _hoisted_3 = { class: "carousel--container" }
const _hoisted_4 = { class: "carousel__item" }
const _hoisted_5 = { class: "profile--hero" }
const _hoisted_6 = { class: "profile--hero--image" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "profile--hero--quote" }
const _hoisted_9 = { class: "profile--quote" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_carousel, { "wrap-around": true }, {
          addons: _withCtx(() => [
            _createVNode(_component_navigation)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (test, index) => {
              return (_openBlock(), _createBlock(_component_slide, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("blockquote", null, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("img", {
                            src: require(`@/assets/b2b/${test.image}`),
                            alt: test.imageDescription
                          }, null, 8, _hoisted_7)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", null, _toDisplayString(test.quote), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", null, _toDisplayString(test.testimonial), 1),
                        _createElementVNode("cite", null, _toDisplayString(test.client), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}